import { Dialog, DialogBackdrop, DialogPanel, Textarea } from "@headlessui/react";
import { Close } from "../../../assets/icons";
import ButtonGroup from "../button-group";

const okButtonOptions = [
    { id: 1, icon: "", label: "OK", type: "primary", className: 'px-3' }
];
const closeButtonOptions = [
    { id: 2, icon: "", label: "Close", type: "secondary", className: 'px-4' }
];

const ConfirmationDialog: React.FC<{ show: boolean, confirmMsg: string, close?: (show: boolean) => void }> = ({
    show = false,
    confirmMsg = '',
    close = () => { },
}) => {
    return (
        <Dialog open={show} onClose={() => close(false)} className="relative z-[1002]">
            <DialogBackdrop
                transition
                className="fixed inset-0 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
            <div className="fixed inset-0 z-10 w-screen">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="flex dialog-max-height relative transform overflow-hidden rounded-lg border-[2px] border-darkcolor-400 bg-darkcolor-700 text-neutral-25 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm md:min-w-[486px] md:w-[486px]  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="flex flex-col w-full ">
                            <div className="border-b-[2px] border-darkcolor-400 py-5 px-6">
                                <div className="flex flex-row justify-between text-neutral-25">
                                    <div>
                                        <div className="text-[19px] font-semibold">Confirm</div>
                                    </div>
                                    <a href="javascript:void(0)" onClick={() => close(false)}>
                                        <Close />
                                    </a>
                                </div>
                            </div>
                            <div className="px-6 py-12 w-full flex flex-col overflow-y-auto gap-3  border-b-[2px] border-darkcolor-400">
                                {confirmMsg}
                            </div>
                            <div className="flex-row flex gap-3 border-top justify-end items-center py-3 px-6">
                                <ButtonGroup
                                    buttonOptions={okButtonOptions}
                                    handleClick={() => close(true)}
                                />
                                <ButtonGroup
                                    buttonOptions={closeButtonOptions}
                                    handleClick={() => close(false)}
                                />
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>

    );
}

export default ConfirmationDialog;
